import { WidgetsLegacyClientsMain } from '@/widgets/legacy-clients';

export const PagesLegacyClientsMain = () => <WidgetsLegacyClientsMain />;
